import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteData,
  getData,
  getDataById,
  postData,
  postDataWithParams,
  updateData,
} from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getPurchaseOrderFarmer = createAsyncThunk(
  "finance/purchase-order-farmer",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData(
        "/finance/purchase-order-farmer",
        data.token,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPurchaseOrderFarmerById = createAsyncThunk(
  "finance/purchase-order-farmer/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById(
        "/finance/purchase-order-farmer/",
        data.token,
        data.id
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortPurchaseOrderFarmer = createAsyncThunk(
  "finance/purchase-order-farmer/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/finance/purchase-order-farmer/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postPurchaseOrderFarmer = createAsyncThunk(
  "finance/purchase-order-farmer/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/finance/purchase-order-farmer",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deletePurchaseOrderFarmer = createAsyncThunk(
  "finance/purchase-order-farmer/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData(
        "/finance/purchase-order-farmer/",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePurchaseOrderFarmer = createAsyncThunk(
  "finance/purchase-order-farmer/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/finance/purchase-order-farmer/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const purchaseOrderFarmerSlice = createSlice({
  name: "Purchase Order Farmer Store",
  initialState: initialState,
  reducers: {
    addPurchaseOrderFarmer(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortPurchaseOrderFarmer(state, action) {
      state.data.docs = action.payload;
    },
    deletePurchaseOrderFarmer(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editPurchaseOrderFarmer(state, action) {
      let x = state.data.docs.findIndex(
        (item) => item._id === action.payload._id
      );
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getPurchaseOrderFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [getPurchaseOrderFarmer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getPurchaseOrderFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderFarmerById.pending]: (state) => {
      state.isLoading = true;
    },
    [getPurchaseOrderFarmerById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderFarmerById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrderFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [sortPurchaseOrderFarmer.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrderFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postPurchaseOrderFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [postPurchaseOrderFarmer.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postPurchaseOrderFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deletePurchaseOrderFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [deletePurchaseOrderFarmer.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deletePurchaseOrderFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updatePurchaseOrderFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [updatePurchaseOrderFarmer.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updatePurchaseOrderFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const purchaseOrderFarmerActions = purchaseOrderFarmerSlice.actions;

export default purchaseOrderFarmerSlice.reducer;
